//import log from "@/utils/logger";

export default {
    getGradeForSchoolYear(year)
    {
        switch (year)
        {
            case 1:
            case 2:
                return 1;
            case 3:
            case 4:
                return 2;
            case 5:
            case 6:
                return 3;
            default:
                //log.info("invalid grade year " + year + "for buddy")
                return 2;

        }
    }
}